import React from "react";
import { logger } from "@rshbintech.dboul/logger";
import { Skeleton } from "@rshbintech.dboul/core-ui";
import { HeaderProps, HeaderState } from "./types";
import { Header as HeaderFallback } from "./index";

const HeaderRemote = React.lazy(() =>
  import("shared-ui/header").then((module) => ({
    default: module.Header,
  }))
);

export class Header extends React.PureComponent<HeaderProps, HeaderState> {
  state = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    logger.sendError(error);
  }

  render() {
    if (this.state.hasError) {
      return <HeaderFallback {...this.props} />;
    }

    return (
      <React.Suspense
        fallback={
          <HeaderFallback headerClassName={this.props?.headerClassName}>
            <Skeleton.Line height="medium" width="medium" />
          </HeaderFallback>
        }
      >
        <HeaderRemote {...this.props} />
      </React.Suspense>
    );
  }
}
